import ClassNames from "classnames";
import { FunctionComponent, ReactNode } from "react";
import styles from "../stylesheets/components/button.module.css";
import {
  AnchorAttrs,
  ButtonModuleSettings,
  ColorScheme,
} from "../types/index.js";
import { css } from "../utils/emotion.js";
import SmartLink from "./SmartLink.js";

type Styles = Partial<ButtonModuleSettings["global"]>;

interface Props extends Styles {
  className?: string;
  scheme: ColorScheme | undefined;
  anchorAttrs?: AnchorAttrs;
  onClick?: () => void;
  isPreview: boolean;
  children: ReactNode;
}

const Button: FunctionComponent<Props> = ({
  className = "",
  layout = "flat",
  type = "primary",
  // corner = "square",
  scheme,
  anchorAttrs = {},
  children,
  onClick,
  isPreview,
}) => {
  const colors = scheme && scheme[type];
  const content = children || <>&nbsp;</>;

  const classNames = ClassNames(styles.Button, className, {
    [styles["Button--hollow"]]: layout === "hollow",
  });

  const styleClass = colors
    ? css(
        layout === "hollow"
          ? { borderColor: colors.background, color: colors.background }
          : {
              borderColor: colors.background,
              backgroundColor: colors.background,
              color: colors.text,
            },
      )
    : undefined;

  if (onClick || !anchorAttrs.href) {
    return (
      <button className={ClassNames(classNames, styleClass)} onClick={onClick}>
        {content}
      </button>
    );
  }

  return (
    <SmartLink
      isPreview={isPreview}
      anchorAttrs={{
        ...anchorAttrs,
        className: ClassNames(classNames, styleClass),
        children: content,
      }}
    />
  );
};

export default Button;
